/**
 * Segments Swiper — Seção "Quem Atendemos"
 * Módulos: Navigation (arrows), Pagination (bullets), A11y
 */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  if ( !document.querySelector('.segments-swiper') ) return;

  new Swiper('.segments-swiper', {
    modules: [Navigation, Pagination, A11y],

    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,

    breakpoints: {
      480: { slidesPerView: 1.2, spaceBetween: 16 },
      768: { slidesPerView: 2.2, spaceBetween: 20 },
      992: { slidesPerView: 3,   spaceBetween: 24 },
    },

    navigation: {
      nextEl: '.segments-swiper-next',
      prevEl: '.segments-swiper-prev',
    },

    pagination: {
      el: '.segments-swiper-pagination',
      clickable: true,
    },

    a11y: {
      prevSlideMessage: 'Segmento anterior',
      nextSlideMessage: 'Próximo segmento',
    },
  });
});
